import { OpenAPI } from '@rbx/docsite-utilities/dist/browser';

export default function getScopeMarkdown(
  scopes: OpenAPI.OperationObject['x-roblox-scopes'],
): string {
  if (!scopes || scopes.length === 0) {
    return '';
  }

  return scopes
    .map(
      (scope) =>
        `- [\`${scope.name}\`](/cloud/reference/scopes#${scope.name})${scope.description ? `\t${scope.description}` : ''}`,
    )
    .join('\n');
}
